// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"reviewCard_cardContainer__18nJi","userNameContainer":"reviewCard_userNameContainer__goW-V"};